export const DashboardEnum = {
  EmbedUrl: {
    value: 'https://app.powerbi.com/reportEmbed?reportId=4e6691d7-5605-4c28-a1d4-2a48ae372871&groupId=eb31180a-7ca1-4a8d-b847-cee9bffcc291&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVdFU1QtRVVST1BFLUItUFJJTUFSWS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCIsImVtYmVkRmVhdHVyZXMiOnsibW9kZXJuRW1iZWQiOnRydWUsImFuZ3VsYXJPbmx5UmVwb3J0RW1iZWQiOnRydWUsImNlcnRpZmllZFRlbGVtZXRyeUVtYmVkIjp0cnVlLCJ1c2FnZU1ldHJpY3NWTmV4dCI6dHJ1ZSwic2tpcFpvbmVQYXRjaCI6dHJ1ZX19'
    , id: '4e6691d7-5605-4c28-a1d4-2a48ae372871'
  },
};